<svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    class="app-accent-lighter"
    d="M58 53V24.3815C58 23.3486 57.6004 22.3557 56.8849 21.6107L46.9139 11.2292C46.1597 10.4439 45.1179 10 44.029 10H16C13.7909 10 12 11.7909 12 14V53C12 55.2091 13.7909 57 16 57H30.4H54C56.2091 57 58 55.2091 58 53Z"
  />
  <path
    d="M34 53H20C17.7909 53 16 51.2091 16 49V11C16 8.79086 17.7909 7 20 7H47.2951C48.3843 7 49.4264 7.44415 50.1807 8.22987L59.8855 18.3391C60.6007 19.084 61 20.0766 61 21.1092V49C61 51.2091 59.2091 53 57 53H43"
    stroke="#484B4D"
    stroke-width="1.3"
  />
  <path
    d="M27 7V9.5V19C27 20.1046 27.8954 21 29 21H46C47.1046 21 48 20.1046 48 19V9.5V7"
    stroke="#484B4D"
    stroke-width="1.3"
  />
  <path
    d="M23 52.5V41C23 38.7909 24.7909 37 27 37H50C52.2091 37 54 38.7909 54 41V52.5"
    stroke="#484B4D"
    stroke-width="1.3"
  />
  <path
    d="M30 42.5H47.5"
    stroke="#484B4D"
    stroke-width="1.3"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <mask id="path-6-inside-1" fill="white">
    <rect x="39" y="11" width="6" height="6" rx="1" />
  </mask>
  <rect
    x="39"
    y="11"
    width="6"
    height="6"
    rx="1"
    stroke="#484B4D"
    stroke-width="2.6"
    mask="url(#path-6-inside-1)"
  />
  <path
    d="M34.25 46V55.6552H30L38.5 66L47 55.6552H42.75V46H34.25Z"
    fill="white"
    stroke="#484B4D"
    stroke-width="1.3"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
